module.exports = __webpack_public_path__ + "img/seal_rogue.31810671.svg";